import type { Novidade } from './tipos';

/** Fase 2 (W1): Início em seções com período, barra superior com índices, menu recolhível e faixa de ambiente. */
export const novidadeInicio: Novidade = {
  id: '2026-10-05-inicio',
  publicada_em: '2026-10-05',
  tipo: 'melhoria',
  modulo: null,
  permissao: null,
  textos: {
    pt: {
      titulo: 'Início em seções, com período e índices',
      resumo: 'Os cards do Início estão em seções, obedecem ao período escolhido e cada valor aparece na sua moeda.',
      passos: [
        'No Início, escolha o período (mês atual, mês passado, 30 dias, trimestre, ano ou personalizado). A escolha fica no link.',
        'Os cards de fluxo seguem o período e comparam com o anterior; os de posição dizem Hoje e os de fila dizem Agora.',
        'A barra superior mostra IGP-M, IPCA, INPC e SELIC do Banco Central, atualizados todo dia.',
        'O menu lateral recolhe pelo botão do topo e abre de novo ao passar o mouse ou com o teclado.',
      ],
    },
    en: {
      titulo: 'Home in sections, with period and indexes',
      resumo: 'Home cards are grouped in sections, follow the chosen period and each amount shows in its own currency.',
      passos: [
        'On Home, choose the period (this month, last month, 30 days, quarter, year or custom). The choice stays in the link.',
        'Flow cards follow the period and compare with the previous one; position cards say Today and queue cards say Now.',
        'The top bar shows IGP-M, IPCA, INPC and SELIC from the Central Bank of Brazil, updated every day.',
        'The side menu collapses with the button at the top and opens again on mouse hover or with the keyboard.',
      ],
    },
    es: {
      titulo: 'Inicio en secciones, con período e índices',
      resumo: 'Las tarjetas del Inicio están en secciones, siguen el período elegido y cada valor aparece en su moneda.',
      passos: [
        'En Inicio, elige el período (mes actual, mes pasado, 30 días, trimestre, año o personalizado). La elección queda en el enlace.',
        'Las tarjetas de flujo siguen el período y comparan con el anterior; las de posición dicen Hoy y las de cola dicen Ahora.',
        'La barra superior muestra IGP-M, IPCA, INPC y SELIC del Banco Central de Brasil, actualizados todos los días.',
        'El menú lateral se contrae con el botón de arriba y se abre de nuevo al pasar el mouse o con el teclado.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-inicio/inicio.webp', null, null, null],
  treinamento: { curso: 'novidades' },
  rota: '/',
};
